export const DEFAULT_CONTENT_SUBDOMAIN = 'fthr-content';

export function getSubdomainPrefix(fullDomain: string | undefined, rootDomain: string): string {
  if (!fullDomain) {
    return '';
  }
  const suffix = `.${rootDomain}`;
  return fullDomain.endsWith(suffix) ? fullDomain.slice(0, -suffix.length) : fullDomain;
}

export function buildSubdomain(
  prefix: string | undefined,
  rootDomain: string,
  defaultPrefix: string,
): string {
  return `${prefix || defaultPrefix}.${rootDomain}`;
}

export function rebaseSubdomain(
  fullDomain: string | undefined,
  previousRootDomain: string,
  nextRootDomain: string,
  defaultPrefix: string,
): string {
  return buildSubdomain(
    getSubdomainPrefix(fullDomain, previousRootDomain),
    nextRootDomain,
    defaultPrefix,
  );
}
